import { useRef, useState, useEffect } from "react";
import { Simuline } from "./Simuline";
import { Paper, TextPaper } from "./desktopState";
import { calcShiftedAfterLine } from "@/utils/utils";


export function TextPaperArtifact({ paper, updatePosition, tool, onCut, onBin }: { paper: TextPaper; updatePosition?: (paper: Paper, pos: [number, number]) => void; tool: "HAND" | "SCISSORS" | "BIN"; onCut: (paper: TextPaper, lineIdx: number) => void; onBin: (paper: Paper) => void; }) {
  const paperRef = useRef<HTMLElement>(null);
  const [grabbing, setGrabbing] = useState(false);

  useEffect(() => {
    if (!updatePosition) return;
    if (!paperRef.current) return;
    if (tool !== "HAND") return;

    paperRef.current.addEventListener("pointerdown", (event) => {
      event.preventDefault();
      setGrabbing(true);
      const paperRect = paperRef.current!.getBoundingClientRect();
      const offsetX = event.clientX - paperRect.left;
      const offsetY = event.clientY - paperRect.top;

      const handlePointerMove = (event: PointerEvent) => {
        event.preventDefault();
        updatePosition(paper, [event.clientX - offsetX, event.clientY - offsetY]);
      };

      const handlePointerUp = (event: PointerEvent) => {
        event.preventDefault();
        setGrabbing(false);
        document.removeEventListener("pointermove", handlePointerMove);
        document.removeEventListener("pointerup", handlePointerUp);
      };

      document.addEventListener("pointermove", handlePointerMove);
      document.addEventListener("pointerup", handlePointerUp);
    });
  }, [updatePosition, paperRef, tool]);

  let shifted = false;
  return <article
    style={{ left: paper.pos[0], top: paper.pos[1] }}
    className={
      `absolute p-4 bg-[#F2E4DB] font-mono text-xs whitespace-pre w-[36rem] shadow overflow-x-hidden
      ${tool === "HAND" ? (grabbing ? "cursor-grabbing" : "cursor-grab") : "cursor-crosshair"}
      ${tool === "BIN" ? "hover:bg-red-100" : ""}`}
    ref={paperRef}
    onClick={() => onBin(paper)}
  >
    {paper.lines.map((line, index) => {
      let result = (
        <div
          key={index}
          className={`border-b-1 min-h-4 border-dashed border-b-transparent ${tool === "SCISSORS" ? "hover:border-b-red-500" : ""}`}
          onClick={() => onCut(paper, index)}
        ><Simuline text={line} shifted={shifted} /></div>
      );
      shifted = calcShiftedAfterLine(shifted, line);
      return result;
    })}
  </article>;
}
